// Français pour le panneau Terminologie. Apostrophe typographique ’ partout. « Save », « Cancel »
// et « Edit » viennent du vocabulaire partagé (i18n/common.fr.ts) et ne sont pas réenregistrés ici.
import { registerFr } from '../i18n/index.js';

registerFr({
  'Terminology': 'Terminologie',
  'The words this engagement uses. Every translation carries them; changing one retranslates what the machine wrote, and leaves what you wrote alone.': 'Les mots qu’emploie ce mandat. Chaque traduction les porte ; en modifier un fait retraduire ce que la machine a écrit, et laisse intact ce que vous avez écrit.',
  'Propose terms from this engagement': 'Proposer des termes tirés de ce mandat',
  'Reading the documents…': 'Lecture des documents…',
  'Proposed — nothing here affects a translation until you activate it': 'Proposés — rien ici n’influe sur une traduction tant que vous ne l’activez pas',
  'In use': 'En usage',
  'No terms yet — every translation is made without a shared vocabulary.': 'Aucun terme pour l’instant — chaque traduction se fait sans vocabulaire commun.',
  'Activate': 'Activer',
  'Discard': 'Écarter',
  'Retire': 'Retirer',
  'Put back in use': 'Remettre en usage',
  'Add the term': 'Ajouter le terme',
  'Never translate this term — it reads the same in every language': 'Ne jamais traduire ce terme — il s’écrit de la même façon dans les trois langues',
  'Hide retired terms': 'Masquer les termes retirés',
  '{n} retired term': '{n} terme retiré',
  '{n} retired terms': '{n} termes retirés',
  'Proposed by the terminology pass over this engagement’s own documents': 'Proposé par la passe de terminologie sur les documents de ce mandat',
  'Written by an operator': 'Saisi par un opérateur',
  'seeded term': 'proposé',
  'operator term': 'saisi',
  '{done} of {expected} translations in place': '{done} traductions sur {expected} en place',
  '{n} still to come': '{n} encore à venir',
  '{n} corrected by hand': '{n} corrigées à la main',
  '{n} need your review — the source changed after you corrected them': '{n} demandent votre relecture — la source a changé après votre correction',
  '{n} miss a term': '{n} omettent un terme',
}, 'TerminologyPanel');
